<template>
  <span v-if="showComponent"
        class="expiration font-weight-light body-2 grey--text"
        :class="{ 'error--text': expirationDateIsPassed, 'font-weight-bold': expirationDateIsPassed }"
  >
    {{ $t('License.expirationDateX', { x: date }) }}
  </span>
</template>

<style scoped>
  .expiration {
    margin-left: 15px;
    position: absolute;
    bottom: 35px;
  }
</style>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'LicenseLimitDate',
    computed: {
      ...mapGetters('license', [
        'expirationDate',
        'expirationDateIsPassed'
      ]),
      showComponent() {
        return this.expirationDate !== null
      },
      date() {
        return new Intl.DateTimeFormat('fr-FR').format(this.expirationDate)
      }
    }
  }
</script>
